import HustonImg from "../../assets/images/events/gallery/huston/1 (3).jpg";
import MIImg from "../../assets/images/events/gallery/grand rapids/day1/1 (1).jpg";
import FriscoImg from "../../assets/images/events/gallery/frisco/day2/118.jpg";
import IngImg from "../../assets/images/events/gallery/ing/1 (64).jpg";
import {
  getTexasThumbnails,
  getMichThumbnails,
  getHustonThumbnails,
  getIngThumbnails,
} from "./loadedImages/getThumbnails";

const texasImages = getTexasThumbnails(400);
const miImages = getMichThumbnails(300);
const dividerLine = <hr style={{ border: "None", margin: ".5rem" }} />;

const EventShowcaseData = [
  {
    title: "DALLAS TEXAS",
    subtitle: "ROUND UP 2026",
    image: FriscoImg,
    galleryThumb: texasImages.slice(0, 8),
    fullGallery: texasImages,
    highlights: (
      <>
        <b>TREMFYA Enhanced Patient Support</b>:
        <br />
        Alena Chapman (J&J PT) shared advanced strategies on how patient support
        programs can bridge the gap between diagnosis and access. Coordinators
        gained a clearer view of navigating complex therapeutic landscapes.
        {dividerLine}
        <b>Provider Round Table, Intro to Specialty Meds</b>: <br />
        Tashara Lester, NP, Sandra Rolfs, PA-C, Dr. Sam Awan, and Brandis
        delivered a powerful, multidisciplinary discussion. This session unified
        clinical and coordination perspectives to better support patient
        journeys.
        {dividerLine}
        <b>Biologics Basics</b>: <br />
        Salina & Crystal laid a strong foundation for understanding biologic
        therapy access. Attendees appreciated the straightforward breakdown of
        core principles for newer coordinators and seasoned professionals alike.
        {dividerLine}
        <b>Infusion Center Discussion</b>: <br />
        Paragon, Vivo, and Keri shared real-world experiences from infusion
        centers. The panel explored barriers to care and how coordinators can
        preemptively address common authorization delays.
        {dividerLine}
        <b>Breakout Series</b>: <br />
        Coordinators chose from powerful tracks including Myositis, IBD,
        Psoriasis, EOE, Asthma, and Clinical Research. Each room was buzzing
        with practical insights, disease-specific challenges, and peer
        strategies for success.
        {dividerLine}
        <b>Provider Presentation</b>: <br />
        Dr. Melissa Costner closed the day with a clinician’s take on access
        coordination and treatment confidence. It was a strong reminder that
        collaboration between providers and coordinators changes patient
        outcomes.
        {dividerLine}
      </>
    ),
    testimonies: (
      <>
        <i>
          “This was the <b>most relevant</b> training I’ve ever attended. Every
          breakout taught something I’ll actually use with patients, providers,
          and payers.”
        </i>
        <br />
        <b>— Attendee, Myositis Track</b>
        {dividerLine}

        <i>
          “Hearing directly from providers helped me understand their pressure
          points and how we, as coordinators, can make their lives <b>easier</b>{" "}
          too.”
        </i>
        <br />
        <b>— Specialty Access Rep</b>
        {dividerLine}

        <i>
          “The Biologics Basics session finally gave me the language to explain
          meds confidently to patients. This bootcamp truly elevated my
          skillset.”
        </i>
        <br />
        <b>— First-Time Biologic Coordinator</b>
        {dividerLine}

        <i>
          “It’s not just education—it’s <b>empowerment</b>. I left knowing I’m
          not alone in this work and that we’re part of a movement that{" "}
          <b>changes lives</b>.”
        </i>
        <br />
        <b>— Long-Time Coordinator, NY</b>
        {dividerLine}

        <i>
          “From IVIG to EOE, every disease-specific session opened my eyes to
          nuances I hadn’t considered. The presenters didn’t just teach—they
          shared the <b>real trenches</b> of access work.”
        </i>
        <br />
        <b>— Breakout Attendee</b>
      </>
    ),
  },
  {
    title: "MI GRAND RAPIDS",
    subtitle: "2024 ROUND UP",
    image: MIImg,
    galleryThumb: miImages.slice(0, 8),
    fullGallery: miImages,
    highlights: (
      <>
        <b>Skin of Color Presentation</b>: <br />
        Ferrell E. Phelps opened minds with a powerful talk on equity in
        dermatologic care. Attendees left with a deeper understanding of how
        skin presentations vary across patients, and why access must be
        inclusive.
        {dividerLine}
        <b>Comorbidities & Coordination</b>: <br />
        The Saturday morning session emphasized real-world challenges faced by
        coordinators managing patients with overlapping diagnoses. It reminded
        the room that precision access work starts with a whole-patient view.
        {dividerLine}
        <b>Manager’s Role in Supporting a Bio Coordinator</b>: <br />
        Faith spoke truth to the internal structure of coordination teams,
        calling out the importance of support, leadership, and listening. This
        breakout lit a fire under managers to do more.
        {dividerLine}
        <b>Dual Role of BC</b>: <br />
        Susan K. and Kaylie M. helped attendees navigate the complexities of
        clinical vs administrative balance. The energy in the room confirmed
        just how many coordinators wear both hats every single day.
        {dividerLine}
        <b>Sunday Medicaid Session</b>: <br />
        Myishia Rhodes, BSN, RN delivered a no-fluff, high-impact breakdown on
        Medicaid Prior Auths. Coordinators walked away with updated tactics, and
        renewed confidence.
        {dividerLine}
        <b>RxNexus Lyceum</b>: <br />
        Sunday closed strong with actionable insights for working smarter with
        pharmacy systems. The Q&A that followed turned into a masterclass on
        real-world payer pushback strategies.
        {dividerLine}
      </>
    ),
    testimonies: (
      <>
        <i>
          “The <b>Skin of Color</b> presentation changed how I approach
          dermatology requests. It’s not just clinical,
          <b>it’s cultural competency</b> in action.”
        </i>
        <br />
        <b>— Biologic Coordinator, Atlanta</b>
        {dividerLine}

        <i>
          “Faith’s session on supporting coordinators hit me hard. I’ve been
          doing this alone for too long, this gave me permission to{" "}
          <b>ask for backup</b>.”
        </i>
        <br />
        <b>— Access Specialist, Midwest</b>
        {dividerLine}

        <i>
          “Dual Role of BC helped me realize I’m not crazy for feeling stretched
          thin. Hearing Susan and Kaylie say it out loud was <b>everything</b>.”
        </i>
        <br />
        <b>— Breakout Attendee</b>
        {dividerLine}

        <i>
          “Myishia Rhodes made Medicaid prior auths finally make <b>sense</b>.
          I’ve never felt this confident walking into a payer call.”
        </i>
        <br />
        <b>— RN Case Manager, NY</b>
        {dividerLine}

        <i>
          “ACBC isn’t just education. It’s <b>recognition</b> of the work, the
          fight, and the heart it takes to be a coordinator.”
        </i>
        <br />
        <b>— First-Time Attendee</b>
      </>
    ),
    reverse: true,
  },
  {
    title: "Houston Texas",
    subtitle: "2024 ROUND UP",
    image: HustonImg,
    galleryThumb: getHustonThumbnails(8),
    fullGallery: getHustonThumbnails(100),
    highlights: (
      <>
        <b>Dual Role of a BC</b>: <br />
        Stephanie L. & Amber B. dove deep into what it
        <i>really</i> means to balance access and advocacy. This session
        resonated with many coordinators juggling administrative demands while
        staying rooted in patient-first care.
        {dividerLine}
        <b>Buy and Bill 101 & 102</b>: <br />
        Tyler M. broke down the process with clarity and confidence, giving
        coordinators tools they can use immediately. Attendees left feeling
        empowered to navigate reimbursement with accuracy and assurance.
        {dividerLine}
        <b>Front Office and Back Office Collaboration</b>: <br />
        Susan K. and Lisa B. emphasized communication as the heart of access
        coordination. Real-world examples showed how seamless teamwork leads to
        faster patient support and fewer treatment delays.
        {dividerLine}
        <b>Sotyktu 360 Patient Support</b>: <br />
        Brandis Boyd-Cooper shared compassionate approaches to simplifying
        patient access. Her insights highlighted how empathy and systems can
        work together to close care gaps.
        {dividerLine}
        <b>Speaking and Communication Training</b>: <br />
        Danny Thorton inspired attendees with practical, empowering skills to
        better advocate for patients. This powerful session reminded
        coordinators that how you speak can open doors to treatment access just
        as much as what you say.
        {dividerLine}
      </>
    ),
    testimonies: (
      <>
        <i>
          “Every breakout gave me real tools I can use with patients on{" "}
          <b>Monday</b>. This BootCamp didn’t just talk about access—it equipped
          us to fight for it.”
        </i>
        <br />
        <b>— Biologic Coordinator, Richmond, VA</b>
        {dividerLine}

        <i>
          “From prior auths to appeals, every session was a reminder that we
          don’t just move paper—we move <b>people</b> closer to the care they
          deserve.”
        </i>
        <br />
        <b>— Access Coordinator Attendee</b>
        {dividerLine}

        <i>
          “Tyler’s <b>Buy & Bill 101</b> session was a game changer. It’s not
          just billing, it’s <b>patient stability</b> on the line.”
        </i>
        <br />
        <b>— Specialty Access Rep, Texas</b>
        {dividerLine}

        <i>
          “Hearing Brandis and Misti talk accumulators made the most confusing
          topic finally <b>click</b>. Now I feel confident tackling it with
          providers and payers.”
        </i>
        <br />
        <b>— Patient Access Lead, Midwest</b>
        {dividerLine}

        <i>
          “Access Coordinators BootCamp isn’t just professional development—it’s
          a<b>movement</b>.”
        </i>
        <br />
        <b>— First-Time Attendee</b>
        {dividerLine}
      </>
    ),
  },
  {
    title: "Inaugural Event: Houston Texas",
    subtitle: "2023 ROUND UP",
    image: IngImg,
    galleryThumb: getIngThumbnails(8),
    fullGallery: getIngThumbnails(100),
    highlights: (
      <>
        What began as a vision from God for two years manifested and took root
        in Houston. The very first ACBC BootCamp brought together a passionate,
        determined group of Biologic Coordinators, Access Specialists, and
        Healthcare Advocates, united by one mission: to break down barriers to
        specialty care.
        {dividerLine}
        Sessions covered everything from Buy & Bill to CoverMyMeds, biosimilars
        to payer criteria, but what truly stood out was the heart in the room.
        Each attendee came seeking answers and left with confidence, clarity,
        and community.
        {dividerLine}
        The energy in Houston was electric, the support was real, and the
        impact? Undeniable.
        <i>This wasn’t just an event, it was the beginning of a movement.</i>
        {dividerLine}
      </>
    ),
    testimonies: (
      <>
        <i>
          “Houston recently hosted its first Access Coordinator Boot Camp,
          providing valuable knowledge on navigating the ‘behind the scenes’
          busy work that biocoordinators endure to get patients on therapy.”
        </i>
        <br />
        <b>— Medical Professional, PACS</b>
        {dividerLine}

        <i>
          “Have had the most wonderful weekend. Surrounded by very knowledgeable
          and professional people that do everything they can for their
          patients. Can’t wait until next time.”
        </i>
        <br />
        <b>— Biologic Coordinator</b>
        {dividerLine}

        <i>
          “The Texas RoundUp was more than professional development, it was a
          space to connect with others who fight the same battles and carry the
          same heart for patient care.”
        </i>
        <br />
        <b>— Event Attendee, Houston</b>
        {dividerLine}
      </>
    ),
    reverse: true,
  },
];

export default EventShowcaseData;
